<nav [@loadedFadeAnimation]="'visible'" class="navbar navbar-expand-lg navbar-light top-navbar bg-white shadow-sm fixed-top">
  <div class="container-fluid">
    <a class="navbar-brand" [routerLink]="['/home']">
      <img src="../../../assets/images/my-posventa-logo.svg" alt="MY Posventa" class="logo-header d-block d-lg-none d-xxl-block">
      <img src="../../../assets/images/my-posventa-logo-sm.svg" alt="MY Posventa" class="logo-header-sm d-none d-lg-block d-xxl-none"></a>
    <button class="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#navbarMenuContainer" aria-controls="navbarMenuContainer" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarMenuContainer">
      <ul class="navbar-nav components me-lg-auto" app-menu *ngIf="menu != null" [items]="menu.Items" [idparent]=" 'MainMenu'" [excludedLinkClass]="'admin-menu-link'" id="MainMenu">
      </ul>
      <ul id="MainAdminMenuMobile" class="navbar-nav components me-lg-auto d-lg-none" app-menu *ngIf="menu != null" [items]="menu.Items" [excludedLinkClass]="''">
      </ul>
      <div id="MainMenuSpaceHolder" *ngIf="menu == null"></div>
      <!--Header Recursive Buttons-->
      <div [@loadedFadeAnimation]="'visible'" class="HeaderButtons">
        <ul class="navbar-nav me-lg-auto admin-menu d-none d-lg-flex">
          <li class="nav-item dropdown hover">
            <!--<div class="rg-logo"><img src="../../../assets/images/rg-logo-nav.svg" alt="Renault Group"></div>-->
            <a role="button" data-bs-toggle="dropdown" href="#" class="nav-link admin__menu__trigger">
              <img src="../../../assets/images/icons/icon-nav-private-area.svg">
            </a>
            <ul id="MainAdminMenu" class="dropdown-menu dropdown-menu-end animate fade-down" app-menu *ngIf="menu != null" [items]="menu.Items" [excludedLinkClass]="''">
            </ul>
            <div id="MainAdminMenuSpaceHolder" *ngIf="menu == null"></div>
          </li>
        </ul>

        <a [@loadedFadeAnimation]="'visible'" class="HeaderButtons__button" *ngIf="this.countNotification > 0" id="notifBell" (click)="getCountNotification(true)" [hidden]="false" type="button" data-bs-toggle="offcanvas" href="#offcanvasNotification" role="button" aria-controls="offcanvasNotification" title="Notificaciones">
          <div class="HeaderButtons__icon position-relative">
            <img src="../../../assets/images/icons/icon-nav-bell.svg" alt="Notificaciones">
            <span class="position-absolute badge rounded-pill badge-not" *ngIf="this.countNotification> 0">
              {{this.countNotification}}
              <span class="visually-hidden">No leídos</span>
            </span>
          </div>
        </a>

        <!--<div><img src="../../../assets/images/headerbuttons-sep.svg"></div>-->
        <div class="cont__user_session">
          <ng-container *ngIf="userInfo">
            <div [@loadedFadeAnimation]="'visible'" class="cont__user_info">
              <a [routerLink]="['/user-profile',userInfo.IdUser]" title="{{userInfo.CompleteName}}" class="HeaderButtons__user">
                <div class="header__user_icon" title="{{userInfo.CompleteName}}"><img src="../../../assets/images/icons/icon-nav-user.svg"></div>
                <div class="HeaderButtons__text">{{userInfo.CompleteName}}</div>
              </a>
              <div class="select__group">
                <!--Cambio de punto de red-->
                <div *ngIf="userInfo.UserCanChangeDistributor && userInfo.Distributors.length > 1" class="cont_select">
                  <select2 [(ngModel)]="distributorSelected" placeholder="Seleccionar punto de red" [data]="distributorData"></select2>
                  <button type="button" (click)="updateDistributorSelected()" class="btn btn-primary HeaderButtons__icon" title="Cambiar"><img src="../../../assets/images/icons/change-white.svg"></button>
                </div>
                <div *ngIf="!userInfo.UserCanChangeDistributor || userInfo.Distributors.length <= 1" title="{{userInfo.DistributorName}}" class="info_group">
                  {{userInfo.DistributorName}}
                </div>
              </div>
            </div>
          </ng-container>
          <div class="logout_trigger">
            <a (click)="logout()" class="HeaderButtons__icon pointer" title="Cerrar sesión"><img src="../../../assets/images/icons/logout.svg"></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</nav>
<app-popup></app-popup>

<div class="order-alert-card" *ngIf="showOrderAlert">
  <div class="order-alert-card__body">
    <a [routerLink]="['/admin/order-validation']" (click)="orderAlertService.dismissAlert()" class="order-alert-card__text">
      <ng-container *ngIf="orderAlertCount === 1">Ha llegado 1 pedido de campañas locales para validar</ng-container>
      <ng-container *ngIf="orderAlertCount > 1">Han llegado {{ orderAlertCount }} pedidos de campañas locales para validar</ng-container>
      <ng-container *ngIf="router.url.includes('order-validation')"> Recarga la tabla para ver los nuevos pedidos</ng-container>
    </a>
    <button class="order-alert-card__close" (click)="orderAlertService.dismissAlert()" aria-label="Cerrar">&times;</button>
  </div>
</div>

<section [@routeAnimation]="getRouteAnimationData()" class="main-section">
  <router-outlet #outlet="outlet"></router-outlet>
</section>

<!--Off canvas - Notifications -->
<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasNotification" aria-labelledby="offcanvasNotificationLabel">
  <div class="offcanvas-header">
    <h5 class="offcanvas-title" id="offcanvasNotificationLabel">Alertas</h5>
    <button id="closeModalButton" type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>

  <div class="offcanvas-body" *ngIf="showNotifications && this.countNotification > 0 && this.data.length > 0">
    <ng-container *ngFor="let item of this.data">
      <div class="cont__alert">
        <div class="date">
          {{item.PublishSince}}
        </div>
        <ng-container *ngIf="item.Url != null">
          <a *ngIf="item.Url != null && item.Url.length > 0 && item.ExternalUrl == true && item.QueryParam == null" href="{{item.Url}}" target="{{item.UrlOpenNew == true? '_blank':''}}" (click)="closeNotification(item.IdNotification)">
            <h6>{{item.Title}}</h6>
            <div class="cont__text_alert">
              <div [innerHTML]="item.Content" class="text_alert"></div>
              <div class="icon__link"></div>
            </div>
          </a>
          <a *ngIf="item.Url != null && item.Url.length > 0 && item.ExternalUrl == false && item.QueryParam == null" class="pointer" [routerLink]="[item.Url]" target=" {{item.UrlOpenNew==true? '_blank' :''}}" (click)="closeNotification(item.IdNotification)">
            <h6>{{item.Title}}</h6>
            <div class="cont__text_alert">
              <div [innerHTML]="item.Content" class="text_alert"></div>
              <div class="icon__link"></div>
            </div>
          </a>
          <a *ngIf="item.Url != null && item.Url.length > 0 && item.ExternalUrl == false && item.QueryParam != null" class="pointer" (click)="routerLinkQueryParams(item.Url,item.QueryParam,item.ParamValue,item.IdNotification)">
            <h6>{{item.Title}}</h6>
            <div class="cont__text_alert">
              <div [innerHTML]="item.Content" class="text_alert"></div>
              <div class="icon__link"></div>
            </div>
          </a>
        </ng-container>
        <ng-container *ngIf="item.Url == null">
          <h6>{{item.Title}}</h6>
          <div [innerHTML]="item.Content" class="text_alert"></div>
        </ng-container>
      </div>
    </ng-container>
    <button class="btn btn-primary mt-5" (click)="loadMore()" *ngIf="showMore">CARGAR MÁS</button>
  </div>
</div>

<app-support-widget *ngIf="userCanSeeIABot" (fabClicked)="closeInjectedSupportWidgets()" (miaSelected)="openMiaSupport()" (contactSelected)="openContactSupport()">
</app-support-widget>

<button type="button" id="back-to-top" class="btn-back-to-top" (click)="scrollToTop()" ngbTooltip="Volver al inicio"><span class="visually-hidden">Volver al inicio</span></button>

<footer [@loadedFadeAnimation]="'visible'" class="main-footer-container">
  <div class="main-footer">
    <div class="info-footer">
      <div class="logo-rg">
        <img src="../../../assets/images/rg-logo-nav.svg" alt="Renault Group" width="130" height="64">
      </div>
      <div class="footer__alert">
        <i class="fa fa-info footer__alert-icon"></i>
        <div class="footer__alert-text">
          <strong>Importante</strong><br />
          El contenido de esta plataforma es estrictamente confidencial. Queda terminantemente prohibida su transmisión total o parcial, directa o indirecta, a terceros.
        </div>
      </div>
    </div>
    <div class="social-footer">
      <div class="social__media">
        <div class="social__links">
          <a class="social_icon" href="https://twitter.com/renaultgroup" target="_blank" rel="noopener noreferrer"><img src="../../../assets/images/footer-tw.svg" alt="Twitter"></a>
          <a class="social_icon" href="https://www.facebook.com/Renault-Group-116825037862" target="_blank" rel="noopener noreferrer"><img src="../../../assets/images/footer-fb.svg" alt="Facebook"></a>
          <a class="social_icon" href="https://www.youtube.com/channel/UCjpe-FourUgOLzzPu9qV4qg" target="_blank" rel="noopener noreferrer"><img src="../../../assets/images/footer-yt.svg" alt="Youtube"></a>
          <a class="social_icon" href="https://www.instagram.com/renaultgroup/" target="_blank" rel="noopener noreferrer"><img src="../../../assets/images/footer-ig.svg" alt="Instagram"></a>
          <a class="social_icon" href="https://www.linkedin.com/company/renaultgroup" target="_blank" rel="noopener noreferrer"><img src="../../../assets/images/footer-in.svg" alt="LinkedIn"></a>
        </div>
      </div>
      <div class="copy-footer">
        <div>
          <strong>© Renault Group Posventa {{ helpers.getCurrentYear() }}</strong> | <a href="https://blobrenault.blob.core.windows.net/prod-renault-marketing-public/MY-Posventa-aviso-legal.pdf" target="_blank" rel="noopener noreferrer">Aviso legal</a>
        </div>
        <!-- <div class="contact">
          <div><strong>Contacto:</strong>&nbsp;
            <a href="mailto:ayuda@myposventa.es">ayuda@myposventa.es</a>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</footer>